/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Job_TypeInputs */

const en_ad_job_type = /** @type {(inputs: Ad_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD Generation`)
};

const fr_ad_job_type = /** @type {(inputs: Ad_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération publicitaire`)
};

const de_ad_job_type = /** @type {(inputs: Ad_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Generation`)
};

const it_ad_job_type = /** @type {(inputs: Ad_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione di annunci pubblicitari`)
};

const ru_ad_job_type = /** @type {(inputs: Ad_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поколение AD`)
};

const es_ad_job_type = /** @type {(inputs: Ad_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generación AD`)
};

const zh_cn2_ad_job_type = /** @type {(inputs: Ad_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`广告生成`)
};

const ja_ad_job_type = /** @type {(inputs: Ad_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告生成`)
};

const hi_ad_job_type = /** @type {(inputs: Ad_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एडी पीढ़ी`)
};

const pt_pt2_ad_job_type = /** @type {(inputs: Ad_Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geração de anúncios`)
};

/**
* | output |
* | --- |
* | "AD Generation" |
*
* @param {Ad_Job_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_job_type = /** @type {((inputs?: Ad_Job_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Job_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_job_type(inputs)
	if (locale === "de") return de_ad_job_type(inputs)
	if (locale === "it") return it_ad_job_type(inputs)
	if (locale === "ru") return ru_ad_job_type(inputs)
	if (locale === "es") return es_ad_job_type(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_job_type(inputs)
	if (locale === "ja") return ja_ad_job_type(inputs)
	if (locale === "hi") return hi_ad_job_type(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_job_type(inputs)
	return en_ad_job_type(inputs)
});